<a class="tab dku-fw500-width"
    [href]="resolvedRoute"
    [class.enabled]="resolvedActive"
    [attr.text-content]="label"
>
    {{label}}
</a>